import { paperClasses } from '@mui/material/Paper';
import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiCard = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        borderRadius: '16px',
        border: theme.palette.mode === 'dark' 
          ? '1px solid rgba(255, 255, 255, 0.08)' 
          : '1px solid rgba(0, 0, 0, 0.06)',
        backgroundImage: 'none',
        transition: 'box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          boxShadow: theme.palette.mode === 'dark'
            ? 'var(--mui-shadows-8)'
            : 'var(--mui-shadows-6)',
        },
        [`&.${paperClasses.elevation1}`]: {
          boxShadow: theme.palette.mode === 'dark'
            ? 'var(--mui-shadows-4)'
            : 'var(--mui-shadows-2)',
        },
        [`&.${paperClasses.elevation2}`]: {
          boxShadow: theme.palette.mode === 'dark'
            ? 'var(--mui-shadows-6)'
            : 'var(--mui-shadows-4)',
        },
        [`&.${paperClasses.elevation3}`]: {
          boxShadow: theme.palette.mode === 'dark'
            ? 'var(--mui-shadows-8)'
            : 'var(--mui-shadows-6)',
        },
      };
    },
  },
} satisfies Components<Theme>['MuiCard'];
